import AuctionWinnerDeclartion from "./WinnerDeclartionForm/AuctionWinnerDeclartion"
import WinnerDeclartionForm from './WinnerDeclartionForm/WinnerDeclartionForm'

export {AuctionWinnerDeclartion,WinnerDeclartionForm}
